module.exports = __webpack_public_path__ + "static/loading.0f381d0f.gif";